import "./services.css";
import { ServiceCard } from "./ServiceCard";

export function Services() {
  return (
    <section id="services" className="section">
      <div className="container">
        <h3>Servicios</h3>

        <div className="grid">
          <ServiceCard title="Poda en altura" image="poda-en-altura" />
          <ServiceCard title="Poda sanitaria" image="poda-sanitaria" />
          <ServiceCard title="Extracción de árboles" image="extraccion-de-arboles" />
          <ServiceCard title="Asesoramiento forestal" image="asesoramiento-forestal" />
        </div>
      </div>
    </section>
  );
}